/* ==========================================================================
   CARETO · FACE LAB — animaciones con scroll
   - Escáner de la portada: en ordenador se queda fijo y cada tramo de scroll
     cambia de cara; en móvil cambian solas cada X segundos.
   - Carrusel: en ordenador se queda fijo y avanza en horizontal con el scroll;
     en móvil es un carrusel normal que se arrastra.
   - Tarjetas que se inclinan con el ratón, cifras que cuentan y fotos con
     parallax. Sin GSAP (o con "reducir movimiento") todo se ve quieto y bien.
   ========================================================================== */
(function () {
  var html = document.documentElement;
  html.classList.add('cx-js');
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var grande = window.matchMedia('(min-width: 990px)');

  function listo(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- Aparecer al llegar + cifras que cuentan ---------- */
  function observa() {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visto');
        e.target.querySelectorAll('[data-cx-cuenta]').forEach(cuenta);
        io.unobserve(e.target);
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('[data-cx-sube]').forEach(function (el) { io.observe(el); });
  }
  function cuenta(el) {
    var fin = parseFloat(String(el.getAttribute('data-cx-cuenta')).replace(',', '.'));
    if (isNaN(fin) || quieto) return;
    var t0 = null, dur = 1400;
    (function paso(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur), v = fin * (1 - Math.pow(1 - k, 3));
      el.textContent = fin % 1 ? v.toFixed(1).replace('.', ',') : Math.round(v);
      if (k < 1) requestAnimationFrame(paso);
    })(performance.now());
  }

  /* ---------- Escáner de caras ---------- */
  function escaner(sec) {
    var caras = sec.querySelectorAll('[data-cx-cara]');
    var puntos = sec.querySelectorAll('.cx-contador span');
    var datos = [];
    try { datos = JSON.parse(sec.querySelector('[data-cx-datos]').textContent); } catch (e) {}
    var hud = {};
    sec.querySelectorAll('[data-cx-hud]').forEach(function (b) { hud[b.getAttribute('data-cx-hud')] = b; });
    var actual = 0;
    function pon(i) {
      if (i === actual || !caras[i]) return;
      caras[actual].classList.remove('is-on'); if (puntos[actual]) puntos[actual].classList.remove('is-on');
      caras[i].classList.add('is-on'); if (puntos[i]) puntos[i].classList.add('is-on');
      actual = i;
      var d = datos[i] || {};
      if (hud.nombre) hud.nombre.textContent = d.nombre || '';
      if (hud.dato1) hud.dato1.textContent = d.dato1 || '';
      if (hud.dato2) hud.dato2.textContent = d.dato2 || '';
      if (hud.pct) hud.pct.textContent = (d.pct || '') + '%';
    }
    var reloj = null;
    function automatico() {
      if (reloj || quieto || caras.length < 2) return;
      var s = parseFloat(sec.getAttribute('data-intervalo')) || 1.8;
      reloj = setInterval(function () { pon((actual + 1) % caras.length); }, s * 1000);
    }
    function para() { clearInterval(reloj); reloj = null; }

    if (window.gsap && window.ScrollTrigger && !quieto) {
      var mm = gsap.matchMedia();
      mm.add('(min-width: 990px)', function () {
        para();
        var pin = sec.querySelector('[data-cx-hero-pin]');
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: sec, start: 'top top', end: '+=' + (caras.length * 55) + '%', pin: pin, scrub: 0.6,
            onUpdate: function (st) { pon(Math.min(caras.length - 1, Math.floor(st.progress * caras.length * 0.999))); }
          }
        });
        tl.to(sec.querySelector('[data-cx-t1]'), { xPercent: -22, opacity: .35, ease: 'none' }, 0)
          .to(sec.querySelector('[data-cx-t2]'), { xPercent: 22, ease: 'none' }, 0)
          .fromTo(sec.querySelector('[data-cx-escaner]'), { scale: 0.92, rotate: -2 }, { scale: 1.06, rotate: 2, ease: 'none' }, 0);
        return function () { automatico(); };
      });
      mm.add('(max-width: 989px)', function () { automatico(); return para; });
    } else {
      automatico();
    }
  }

  /* ---------- Carrusel horizontal ---------- */
  function carrusel(sec) {
    if (!window.gsap || !window.ScrollTrigger || quieto) return;
    var pista = sec.querySelector('[data-cx-pista]');
    var barra = sec.querySelector('[data-cx-barra]');
    var mm = gsap.matchMedia();
    mm.add('(min-width: 990px)', function () {
      var dist = function () { return Math.max(0, pista.scrollWidth - window.innerWidth); };
      if (dist() < 40) return;
      gsap.to(pista, {
        x: function () { return -dist(); }, ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top top', end: function () { return '+=' + dist(); }, pin: sec.querySelector('[data-cx-carrusel-pin]'), scrub: 0.8, invalidateOnRefresh: true,
          onUpdate: function (st) { if (barra) barra.style.transform = 'scaleX(' + st.progress + ')'; } }
      });
    });
  }

  /* ---------- Inclinación con el ratón ---------- */
  function inclina(el) {
    if (quieto || !window.matchMedia('(hover: hover)').matches) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) translateY(-6px)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  /* ---------- Parallax de fotos ---------- */
  function parallax(el) {
    if (!window.gsap || !window.ScrollTrigger || quieto) return;
    var m = el.querySelector('img, video'); if (!m) return;
    gsap.fromTo(m, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
  }

  function arranca() {
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      var engancha = function () { if (window.asLenis && !window.asLenis.__cx) { window.asLenis.on('scroll', ScrollTrigger.update); window.asLenis.__cx = true; } };
      engancha(); setTimeout(engancha, 800);
    }
    observa();
    document.querySelectorAll('[data-cx-hero]').forEach(escaner);
    document.querySelectorAll('[data-cx-carrusel]').forEach(carrusel);
    document.querySelectorAll('[data-cx-tilt]').forEach(inclina);
    document.querySelectorAll('[data-cx-parallax]').forEach(parallax);
    if (window.ScrollTrigger) {
      window.addEventListener('load', function () { ScrollTrigger.refresh(); });
      setTimeout(function () { ScrollTrigger.refresh(); }, 1000);
    }
  }
  listo(arranca);
})();
